import { AlertTriangle } from 'lucide-react';

import type { ProjectDocComplianceFailure } from '@/features/end-of-lease/types';

import {
    Alert,
    AlertDescription,
    AlertTitle,
} from '@/components/ui/alert';

interface Props {
    failures: ProjectDocComplianceFailure[];
}

const AIRCRAFT_IDENTITY_CHECK_TYPE = 'status_report_aircraft_identity';

export function ComplianceFailureAlert({ failures }: Props) {
    const aircraftIdentityFailures = failures.filter(
        (f) => f.checkType === AIRCRAFT_IDENTITY_CHECK_TYPE,
    );

    if (aircraftIdentityFailures.length === 0) {
        return null;
    }

    return (
        <Alert
            variant="warning"
            data-testid="ComplianceFailureAlert"
        >
            <AlertTriangle className="h-4 w-4" />
            <AlertTitle>
                Aircraft Identity Mismatch Detected ({aircraftIdentityFailures.length}{' '}
                {aircraftIdentityFailures.length === 1 ? 'document' : 'documents'})
            </AlertTitle>
            <AlertDescription>
                <ul className="mt-1 space-y-1 list-disc list-inside text-sm">
                    {aircraftIdentityFailures.map((f) => (
                        <li key={`${f.targetId}-${f.complianceCheckId}`}>
                            {f.docFilename && (
                                <span className="font-medium">{f.docFilename}: </span>
                            )}
                            {f.message}
                        </li>
                    ))}
                </ul>
            </AlertDescription>
        </Alert>
    );
}
